module.exports = __webpack_public_path__ + "img/page_2.067e3f26.png";